import { useState } from 'react';

const TAGS = [
  { key: 'manufacture', emoji: '🔨', label: 'Manufacture', color: '#8B4513', bg: 'rgba(139,69,19,0.1)' },
  { key: 'ordered',     emoji: '📦', label: 'Ordered',     color: '#1a6b3c', bg: 'rgba(26,107,60,0.1)'  },
  { key: 'door',        emoji: '🚪', label: 'Door',        color: '#1a4a8a', bg: 'rgba(26,74,138,0.1)'  },
  { key: 'trim',        emoji: '🪵', label: 'Trim',        color: '#7a4a00', bg: 'rgba(122,74,0,0.1)'   },
  { key: 'adder',       emoji: '➕', label: 'Adder',       color: '#6a1a6a', bg: 'rgba(106,26,106,0.1)' },
];

export function autoDetectTag(description) {
  const d = (description || '').toLowerCase();
  if (d.includes('door') || d.includes('entry') || d.includes('patio')) return 'door';
  if (d.includes('trim') || d.includes('casing') || d.includes('moulding') || d.includes('molding')) return 'trim';
  if (d.includes('install') || d.includes('haul') || d.includes('misc') || d.includes('labor') || d.includes('service')) return 'adder';
  if (d.includes('order') || d.includes('special')) return 'ordered';
  return 'manufacture';
}

export default function LineItemTag({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const current = TAGS.find(t => t.key === value) || TAGS[0];

  function select(key) {
    onChange(key);
    setOpen(false);
  }

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        title={current.label}
        style={{
          display: 'flex', alignItems: 'center', gap: '4px',
          padding: '3px 8px', borderRadius: '20px',
          border: `1px solid ${current.color}40`,
          background: current.bg, color: current.color,
          fontSize: '11px', fontWeight: '600', cursor: 'pointer',
          whiteSpace: 'nowrap', transition: 'all 0.15s ease',
          minWidth: '90px', justifyContent: 'center',
        }}
      >
        <span>{current.emoji}</span>
        <span>{current.label}</span>
        <span style={{ fontSize: '9px', opacity: 0.7 }}>▾</span>
      </button>

      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 998 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: 'calc(100% + 4px)', left: '50%',
            transform: 'translateX(-50%)', zIndex: 999,
            background: 'white', borderRadius: '10px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
            border: '1px solid rgba(139,69,19,0.1)',
            padding: '6px', minWidth: '130px',
          }}>
            {TAGS.map(tag => (
              <button
                key={tag.key}
                type="button"
                onClick={() => select(tag.key)}
                style={{
                  display: 'flex', alignItems: 'center', gap: '8px',
                  width: '100%', padding: '6px 10px', borderRadius: '6px',
                  border: 'none', background: tag.key === value ? tag.bg : 'transparent',
                  color: tag.color, fontSize: '12px',
                  fontWeight: tag.key === value ? '700' : '500',
                  cursor: 'pointer', textAlign: 'left',
                }}
              >
                <span>{tag.emoji}</span>
                <span>{tag.label}</span>
                {tag.key === value && <span style={{ marginLeft: 'auto', fontSize: '10px' }}>✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
